var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGcp = function SvgGcp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 37,
    viewBox: "0 0 42 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1981 7.40386L22.9466 0H11.7927C10.7997 0 9.87422 0.530224 9.3922 1.39786L0.368747 17.1214C-0.122916 17.9794 -0.122916 19.0206 0.368747 19.8882L3.80074 25.8749L8.04253 18.5096L14.4245 7.40386H27.1981Z",
    fill: "#F8BB16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.254 17.1214L32.2305 1.39786C31.7292 0.539865 30.8134 0 29.8301 0H22.9468L27.1982 7.40386L33.5802 18.5096L27.1982 29.6154H35.6818L41.254 19.8882C41.736 19.0302 41.736 17.9794 41.254 17.1214Z",
    fill: "#EA4334"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6718 29.6058H14.405L8.02304 18.5L3.78125 25.8653L9.3727 35.6021C9.87401 36.4601 10.7898 37 11.7732 37H29.8104C30.8034 37 31.7289 36.4698 32.2109 35.6021L35.6718 29.6058Z",
    fill: "#0074BC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.179 29.6058H14.3958L8.02344 18.5L14.4054 7.39423H27.179L33.5802 18.5L27.179 29.6058ZM20.797 12.9568C17.7217 12.9568 15.2441 15.4344 15.2441 18.5097C15.2441 21.585 17.7217 24.0626 20.797 24.0626C23.8723 24.0626 26.3499 21.585 26.3499 18.5097C26.3499 15.4344 23.8627 12.9568 20.797 12.9568Z",
    fill: "#E2E3E4"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGcp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gcp.524280a8.svg";
export { ForwardRef as ReactComponent };